import { lightPalette, type AppColors } from './palettes';

/** Mutable singleton — ThemeProvider syncs this when mode changes so legacy imports update. */
export const colors: AppColors = JSON.parse(JSON.stringify(lightPalette)) as AppColors;

export function applyThemeColors(next: AppColors): void {
  const fresh = JSON.parse(JSON.stringify(next)) as AppColors;
  (Object.keys(fresh) as (keyof AppColors)[]).forEach((key) => {
    const value = fresh[key];
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      Object.assign(colors[key] as object, value);
    } else {
      (colors as Record<string, unknown>)[key] = value;
    }
  });
}

applyThemeColors(lightPalette);

export type { AppColors, ThemeMode } from './palettes';
export type { AccentColorId } from './accentColors';
